import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CategoryCard from '../components/CategoryCard';
import { getCategoryImage, getRootCategories } from '../utils/functions';

const PageMain = () => {
  const { t } = useTranslation();
  const { categories } = useContext(PagePropsContext);

  return <div className='page page--main'>
    <Header
      title={t('main.title')}
      showSearch={true}
    />
    <div className='page__content'>
      <div className='categories'>
        {getRootCategories(categories).map((cat, index) => <CategoryCard
          key={cat.id}
          category={cat}
          icon={getCategoryImage(index)}
        />)}
      </div>
    </div>
    <Footer />
  </div>;
}

export default PageMain;